/**
 * 把一条历史任务的 `inputs` 回填成页面表单 —— 历史卡上那颗「重做」用。
 *
 * ## 为什么先「按表单的键挑一遍」，而不是 `patch(job.inputs)`
 *
 * 各页提交时写的载荷是 `inputs: { ...form, __title, channel, skills }` ——
 * 它比表单**多几个系统键**（`__title` / `channel` / `skills` …）。
 * 直接整份 `patch` 回去，那几个键会被并进草稿并落 localStorage：
 * 草稿从此多出一批界面上没有的字段，下一次读回来还会带进载荷 ——
 * 属于「看不见的脏数据」，排查时对不上任何一处 UI。
 *
 * 白名单取**页面当前的表单值**本身：它由 `useDraft(key, DEFAULTS)` 合并而来，
 * 键集就是这一页表单的形状。拿它当白名单，加字段 / 删字段时这里自动跟着变，
 * 没有第二份清单要同步 —— 也省得每个页面再传一个 `DEFAULTS` 进来。
 *
 * ## 挑不到的键就**不填**（不做任何推断）
 *
 * 老记录可能是别的版本写的（字段改过名、被删过）。挑不到的键留空、
 * 由用户自己补 —— 猜一个值填进去，出来的图和用户以为的不是一回事，
 * 而界面上完全看不出来（本项目最不该犯的一类错）。
 */
export function refillFromInputs<T extends Record<string, unknown>>(
  shape: T,
  inputs: Record<string, unknown> | undefined | null,
): Partial<T> {
  if (!inputs) return {}
  const out: Record<string, unknown> = {}
  for (const key of Object.keys(shape)) {
    if (Object.prototype.hasOwnProperty.call(inputs, key)) out[key] = inputs[key]
  }
  return out as Partial<T>
}
